import { render, staticRenderFns } from "./UserInfoMini.vue?vue&type=template&id=0ba4fdd7&scoped=true&"
import script from "./UserInfoMini.vue?vue&type=script&lang=js&"
export * from "./UserInfoMini.vue?vue&type=script&lang=js&"
import style0 from "./UserInfoMini.vue?vue&type=style&index=0&id=0ba4fdd7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba4fdd7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
installComponents(component, {VList,VListItem})
